import { Link, useLocation } from "react-router";
import ImageWithBasePath from "../image-with-base-path";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "@/core/redux/store";
import { setMobileSidebar } from "@/core/redux/sidebarSlice";
import HeaderNav from "../header/headerNav";
import { all_routes } from "@/routes/all_routes";

const CustomHeader = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const dispatch = useDispatch();
  const menuOpened = useSelector((state: RootState) => {
    const s = state.sidebar as any;
    // try known/possible property names, fallback to false
    return (s.menuOpened ?? s.mobileSidebar ?? s.isOpen ?? false) as boolean;
  });
  const location = useLocation();
  const isPatientPage = location.pathname.startsWith("/patient");

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (menuOpened) document.body.classList.add("menu-opned");
    else document.body.classList.remove("menu-opned");
  }, [menuOpened]);

  const onMobileBtn = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(setMobileSidebar(!menuOpened));
  };

  const onMenuClose = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(setMobileSidebar(false));
  };
  // ...existing code...
  return (
    <>
      {/* Header */}
      <header
        className={`header header-default inner-header  ${
          isScrolled ? "fixed" : ""
        }`}
      >
        <div className="container">
          <nav className="navbar navbar-expand-lg header-nav">
            <div className="navbar-header">
              <Link id="mobile_btn" to="#" onClick={onMobileBtn}>
                <i className="fa-solid fa-bars" />
              </Link>
              <Link to={all_routes.home} className="navbar-brand logo">
                <ImageWithBasePath
                  src="assets/img/logo.svg"
                  className="img-fluid"
                  alt="Logo"
                />
              </Link>
            </div>
            <div className="header-menu">
              <div className="main-menu-wrapper">
                <div className="menu-header">
                  <Link to={all_routes.home} className="menu-logo">
                    <ImageWithBasePath
                      src="assets/img/logo.svg"
                      className="img-fluid"
                      alt="Logo"
                    />
                  </Link>
                  <Link
                    id="menu_close"
                    className="menu-close"
                    to="#"
                    onClick={onMenuClose}
                  >
                    <i className="fas fa-times" />
                  </Link>
                </div>
                <HeaderNav />
                <div className="header-items">
                  {/* Item 1 */}
                  <div className="about-popup-item border-0 pb-0">
                    <h3 className="title">Contact Information</h3>
                    <div className="support-item mb-3">
                      <div className="avatar avatar-lg bg-primary rounded-circle">
                        <i className="isax isax-messages-3" />
                      </div>
                      <div>
                        <p className="title">General Inquiries</p>
                        <h5 className="link">info@example.com</h5>
                      </div>
                    </div>
                    <div className="support-item">
                      <div className="avatar avatar-lg bg-primary rounded-circle">
                        <i className="isax isax-call-calling" />
                      </div>
                      <div>
                        <p className="title">Emergency Cases</p>
                        <h5 className="link">+1 24565 89856</h5>
                      </div>
                    </div>
                  </div>
                  {/* Item 2 */}
                  <div className="about-popup-item border-0 pb-0">
                    <h3 className="title">Follow Us</h3>
                    <ul className="d-flex align-items-center gap-2 social-iyem">
                      <li>
                        <Link to="#" className="social-icon">
                          <i className="fa-brands fa-facebook" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="social-icon">
                          <i className="fa-brands fa-x-twitter" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="social-icon">
                          <i className="fa-brands fa-instagram" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="social-icon">
                          <i className="fa-brands fa-linkedin" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="header-items-button">
                    <Link
                      to={all_routes.login}
                      className="btn btn-primary btn-primary-gradient"
                    >
                      <i className="isax isax-lock-1 me-2" />
                      Logout
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <ul className="nav header-navbar-rht">
              <li className="search-item">
                <Link
                  to="#"
                  className="details-btn"
                  tabIndex={-1}
                  data-bs-toggle="offcanvas"
                  data-bs-target="#search_popup"
                  aria-controls="search_popup"
                >
                  <i className="isax isax-search-normal-1" />
                </Link>
              </li>
              <li className="noti-nav dropdown">
                <Link
                  to="#"
                  className="details-btn"
                  data-bs-toggle="dropdown"
                  aria-label="Notification"
                >
                  <i className="isax isax-notification-bing" />
                  <span className="badge" />
                </Link>
                <div className="dropdown-menu notifications dropdown-menu-end">
                  <div className="topnav-dropdown-header">
                    <span className="notification-title">Notifications</span>
                  </div>
                  <div className="noti-content">
                    <ul className="notification-list">
                      <li className="notification-message">
                        <Link to="#">
                          <div className="notify-block d-flex">
                            <span className="avatar">
                              <ImageWithBasePath
                                className="avatar-img"
                                alt="Ruby perin"
                                src="assets/img/clients/client-01.jpg"
                              />
                            </span>
                            <div className="media-body">
                              <h6>
                                Travis Tremble{" "}
                                <span className="notification-time">
                                  18.30 PM
                                </span>
                              </h6>
                              <p className="noti-details">
                                Sent a amount of $210 for his Appointment{" "}
                                <span className="noti-title">
                                  Dr.Ruby perin{" "}
                                </span>
                              </p>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="notification-message">
                        <Link to="#">
                          <div className="notify-block d-flex">
                            <span className="avatar">
                              <ImageWithBasePath
                                className="avatar-img"
                                alt="Hendry Watt"
                                src="assets/img/clients/client-02.jpg"
                              />
                            </span>
                            <div className="media-body">
                              <h6>
                                Kelly Stevens{" "}
                                <span className="notification-time">
                                  12 Min Ago
                                </span>
                              </h6>
                              <p className="noti-details">
                                {" "}
                                has booked her appointment to{" "}
                                <span className="noti-title">
                                  Dr. Hendry Watt
                                </span>
                              </p>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="notification-message">
                        <Link to="#">
                          <div className="notify-block d-flex">
                            <div className="avatar">
                              <ImageWithBasePath
                                className="avatar-img"
                                alt="Maria Dyen"
                                src="assets/img/clients/client-03.jpg"
                              />
                            </div>
                            <div className="media-body">
                              <h6>
                                Robert Joe{" "}
                                <span className="notification-time">
                                  6 Min Ago
                                </span>
                              </h6>
                              <p className="noti-details">
                                {" "}
                                Sent a amount $210 for his Appointment{" "}
                                <span className="noti-title">
                                  Dr.Maria Dyen
                                </span>
                              </p>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="notification-message">
                        <Link to="#">
                          <div className="notify-block d-flex">
                            <div className="avatar avatar-sm">
                              <ImageWithBasePath
                                className="avatar-img"
                                alt="client-image"
                                src="assets/img/clients/client-04.jpg"
                              />
                            </div>
                            <div className="media-body">
                              <h6>
                                Samuel Jord{" "}
                                <span className="notification-time">
                                  8.30 AM
                                </span>
                              </h6>
                              <p className="noti-details">
                                {" "}
                                Send a message to his doctor
                              </p>
                            </div>
                          </div>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li>
                <Link
                  to="#"
                  className="details-btn"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#support_item"
                >
                  <i className="isax isax-menu5" />
                </Link>
              </li>
              {isPatientPage ? (
                <li className="dropdown has-arrow logged-item patient-header">
                  <Link to="#" data-bs-toggle="dropdown">
                    <span className="user-img">
                      <ImageWithBasePath
                        className="rounded-circle"
                        src="assets/img/doctors-dashboard/profile-06.jpg"
                        alt="Darren Elder"
                      />
                    </span>
                  </Link>
                  <div className="dropdown-menu dropdown-menu-end">
                    <div className="user-header">
                      <div className="avatar">
                        <ImageWithBasePath
                          src="assets/img/doctors-dashboard/profile-06.jpg"
                          alt="User Image"
                          className="avatar-img rounded-circle"
                        />
                      </div>
                      <div className="user-text">
                        <h6>Hendrita Hayes</h6>
                        <p className="text-muted mb-0">Patient</p>
                      </div>
                    </div>
                    <Link className="dropdown-item" to={all_routes.patientDashboard}>
                      Dashboard
                    </Link>
                    <Link className="dropdown-item" to={all_routes.patientProfileSettings}>
                      Profile Settings
                    </Link>
                    <Link className="dropdown-item" to={all_routes.login}>
                      Logout
                    </Link>
                  </div>
                </li>
              ) : (
                <li className="dropdown has-arrow logged-item">
                  <Link to="#" data-bs-toggle="dropdown">
                    <span className="user-img">
                      <ImageWithBasePath
                        className="rounded-circle"
                        src="assets/img/doctors-dashboard/doctor-profile-img.jpg"
                        alt="Darren Elder"
                      />
                    </span>
                  </Link>
                  <div className="dropdown-menu dropdown-menu-end">
                    <div className="user-header">
                      <div className="avatar">
                        <ImageWithBasePath
                          src="assets/img/doctors-dashboard/doctor-profile-img.jpg"
                          alt="User Image"
                          className="avatar-img rounded-circle"
                        />
                      </div>
                      <div className="user-text">
                        <h6>Dr Edalin Hendry</h6>
                        <p className="text-muted mb-0">Doctor</p>
                      </div>
                    </div>
                    <Link
                      className="dropdown-item"
                      to={all_routes.doctorDashboard}
                    >
                      Dashboard
                    </Link>
                    <Link
                      className="dropdown-item"
                      to={all_routes.doctorProfileSettings}
                    >
                      Profile Settings
                    </Link>
                    <Link className="dropdown-item" to={all_routes.login}>
                      Logout
                    </Link>
                  </div>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </header>
      {/* /Header */}
    </>
  );
};

export default CustomHeader;
